export default __webpack_public_path__ + "static/media/discovery-02.aebcbeb6.png";